// extracted by mini-css-extract-plugin
module.exports = {"main-page-section-title":"_3mpCcOyb16LAozQ8O9QG9P","main-page-section-title__separator":"_1mvEbfIUfzqT1Ae5Obq6fg"};